var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhaleTail1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8231,
    stopColor: "#0590fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0182fc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 243.338,
    y2: 536.988
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0182fc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.78,
    x2: 285.509,
    xlinkHref: "#lg2",
    y1: 342.604,
    y2: 3.082
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.451,
    x2: 276.956,
    xlinkHref: "#lg2",
    y1: 385.994,
    y2: 143.665
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 418.022,
    y2: 473.168
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.207,
    x2: 347.132,
    xlinkHref: "#lg1",
    y1: 188.797,
    y2: 208.722
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.375,
    x2: 406.539,
    xlinkHref: "#lg1",
    y1: 218.129,
    y2: 237.293
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 372.125,
    x2: 383.17,
    xlinkHref: "#lg1",
    y1: 167.879,
    y2: 178.924
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.579,
    x2: 318.092,
    y1: 71.315,
    y2: 199.097
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7ca1b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#537983"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.204,
    x2: 219.206,
    y1: 108.383,
    y2: 185.299
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.739,
    x2: 132.488,
    xlinkHref: "#lg1",
    y1: 125.632,
    y2: 150.381
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 124.739,
    x2: 135.739,
    xlinkHref: "#lg1",
    y1: 164.632,
    y2: 175.632
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m462.111 209.753c-9.591 5.962-21.716 6.041-31.384.204l-16.493-9.958c-19.567-11.814-44.076-11.784-63.614.079l-.846.513c-19.373 11.762-43.731 11.564-62.91-.512-19.601-11.835-44.146-11.835-63.747.001-19.601 11.836-44.146 11.836-63.747.001l-.002-.001c-20.072-11.621-44.878-11.392-64.733.596l-14.688 8.868c-9.963 6.016-22.44 6.016-32.403 0-20.888-12.615-47.544 2.428-47.544 26.83v217.421c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-217.424c0-24.583-27.011-39.596-47.889-26.618z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 247.401c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.079l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.887-12.615 47.543 2.428 47.543 26.83v179.773c0 11.267-9.133 20.4-20.4 20.4h-469.2c-11.267 0-20.4-9.133-20.4-20.4v-179.777c0-24.582 27.011-39.595 47.889-26.617z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.889 326.401c9.591 5.962 21.716 6.041 31.384.204l16.493-9.958c19.567-11.814 44.076-11.784 63.614.078l.846.513c19.373 11.762 43.731 11.564 62.91-.512 19.601-11.835 44.146-11.835 63.747.001 19.601 11.836 44.146 11.836 63.747.001l.003-.001c20.072-11.621 44.878-11.392 64.733.596l14.688 8.868c9.963 6.016 22.44 6.016 32.403 0 20.887-12.614 47.543 2.429 47.543 26.831v100.773c0 11.267-9.133 20.4-20.4 20.4h-469.2c-11.267 0-20.4-9.133-20.4-20.4v-100.777c0-24.582 27.011-39.595 47.889-26.617z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 382.022v71.773c0 11.267 9.133 20.4 20.4 20.4h469.2c11.267 0 20.4-9.133 20.4-20.4v-71.773z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m363.789 194.616c0-6.435-4.364-12.738-10.999-13.681-33.983-4.83-39.899 33.033-33.203 36.932 6.694 3.895 9.661-13.245 27.146-9.544 8.598 1.82 15.05-3.103 16.723-10.664.226-1.022.333-2.041.333-3.043z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 396.633,
    cy: 227.387,
    fill: "url(#SVGID_6_)",
    r: 16.252
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 378.133,
    cy: 173.887,
    fill: "url(#SVGID_7_)",
    r: 10.242
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m400.37 139.601c-67.39-1.49-104.97 52.16-104.91 102.43-2.94-1.19-5.81-2.63-8.58-4.3-9.8-5.92-20.84-8.88-31.87-8.88s-22.07 2.96-31.87 8.88c-2.77 1.74-5.64 3.24-8.6 4.47.14-50.32-37.44-104.09-104.91-102.6-44.85.99-101.44-30.62-78.34-93.48 3.68-10.03 19.17-13.81 25.99-6.53 10.56 11.29 30.5 21.18 66.27 12.29 66.98-16.66 112.08-9.11 131.45 29.36 19.37-38.47 64.47-46.02 131.45-29.36 35.77 8.89 55.71-1 66.27-12.29 6.82-7.28 22.31-3.5 25.99 6.53 23.1 62.86-33.49 94.47-78.34 93.48z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m400.37 139.601c-67.39-1.49-104.97 52.16-104.91 102.43-2.94-1.19-5.81-2.63-8.58-4.3-9.8-5.92-20.84-8.88-31.87-8.88h-.01v-147.61c19.37-38.47 64.47-46.02 131.45-29.36 35.77 8.89 55.71-1 66.27-12.29 6.82-7.28 22.31-3.5 25.99 6.53 23.1 62.86-33.49 94.47-78.34 93.48z",
    fill: "url(#SVGID_9_)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 114.997,
    cy: 132.89,
    fill: "url(#SVGID_10_)",
    r: 17.666
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.497,
    cy: 170.39,
    fill: "url(#SVGID_11_)",
    r: 10.242
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhaleTail1);
export default __webpack_public_path__ + "static/media/icon-whale-tail-1.476d0c1331c614f41216c85dd38a57dd.svg";
export { ForwardRef as ReactComponent };